import {
  HttpClient,
  HttpContext,
  HttpHeaders,
  HttpParams,
} from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { CCBackendEndpoint, PAGE_CODE } from '@maids/cc-erp-services';
import {
  PageableResponseModel,
  PaginationRequest,
  SearchModel,
} from '@maids/cc-lib/common';
import { SelectOption } from '@maids/cc-lib/select-input';
import { assets } from '@maids/cc-lib/utils';
import { map, Observable, of, switchMap, BehaviorSubject } from 'rxjs';
import { API } from 'src/environments/api';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AppService {
  
  // Add a trigger to force menu refresh
  private _menuRefreshTrigger$ = new BehaviorSubject<number>(0);
  
  constructor(
    private _http: HttpClient,
    @Inject(CCBackendEndpoint) private _api: CCBackendEndpoint
  ) {}

  fetchMenu() {
    const context = new HttpContext().set(PAGE_CODE, 'sidenav_menu');
    return this._menuRefreshTrigger$.pipe(
      switchMap(() => 
        this._http
          .get<any>(
            [this._api, 'admin', 'menu', 'get'].join('/') + '?language=1',
            {context}
          )
          .pipe(switchMap((menu) => this.transformResponse(menu)))
      )
    );
  }

  fetchUserMenu() {
    // needs to be changed to fetchUserMenu
    return this._menuRefreshTrigger$.pipe(
      switchMap(() =>
        this._http
          .get<any>(
            [this._api, 'admin', 'menu', 'getMenu'].join('/') + '?language=1',
            {}
          )
          .pipe(
            switchMap((menu) =>
              of(this.transformResponse(
                menu.filter((resource: any) => resource.active)
              ))
            )
          )
      )
    );
  }
  transformResponse(response: any): any[] {
    return response.map((resource: any) => ({
      type: this.getResourceType(resource),
      text: resource.label,
      icon: resource.icon || '',
      navLink:
        resource.resources && resource.resources.length > 0
          ? null
          : assets.getBasePath() + (environment.newErp ? '' : 'main.html#!') + resource.link,
      expanded: false,
      hidden: !resource.active,
      code: resource.code,
      order: resource.order,
      itemType: resource.type,
      children:
        resource.resources && resource.resources.length > 0
          ? this.transformResponse(resource.resources)
          : null,
    }));
  }

  getResourceType(resource: any) {
    if (resource.type == 'Folder') return 'folder';
    if (resource.resources && resource.resources.length > 0) return 'menu';
    return 'external_link';
  }

  shapeRequest(resources: any, originalOrder: number) {
    return resources.map((item: any, index: number) => ({
      code: item.code,
      active: !item.hidden,
      icon: item.icon,
      label: item.text,
      order: originalOrder + index,
      type: item.itemType,
      linkSuffix: item.linkSuffix,
      resources:
        item.itemType != 'Page'
          ? this.shapeRequest(item.children, originalOrder + index)
          : null,
    }));
  }

  saveMenu(data: any) {
    const context = new HttpContext().set(PAGE_CODE, 'sidenav_menu');
    let request = this.shapeRequest(data, 0);
    return this._http.post<any>(
      [this._api, 'admin', 'menu', 'set'].join('/') + '?language=1',
      request,
      {context}
    );
  }
  
  // Trigger menu refresh for all subscribers
  refreshMenuData() {
    this._menuRefreshTrigger$.next(Date.now());
  }

  // todo-amr: implement the backend api and use it here
  readonly fetchPageCodes = () => {
    return this._http
      .get<any>([this._api, 'admin', 'menu', 'getPageCodes'].join('/'), {})
      .pipe(
        map((pageCodes) =>
          pageCodes.map(
            (pageCode: String) =>
              ({ id: pageCode, text: pageCode } as SelectOption)
          )
        )
      );
  };
}
